



































































































import {mapActions, mapGetters} from 'vuex';
import store from '@/store';
import AppBar from '@/components/template/AppBar.vue';
import vue from 'vue';
import {AdvertType} from '#/Advert';

interface ComponentData {
  dialog: { display: boolean };
  filterSliderActive: boolean;
  navSliderActive: boolean;
  profileLoaded: boolean;
  sideMenuActive: boolean;
  windowHeight: number | null,
}

export default vue.extend({
  name: 'AppTemplate',

  components: {
    AppBar,
    'filter-slider': () => import('@/components/template/FilterSlider.vue'),
    'menu-drawer': () => import('@/components/template/MenuDrawer.vue'),
    'nav-slider': () => import('@/components/template/NavSlider.vue'),
  },

  data: (): ComponentData => ({
    dialog: {display: false},
    filterSliderActive: false,
    navSliderActive: false,
    profileLoaded: false,
    sideMenuActive: false,
    windowHeight: null,
  }),

  computed: {
    ...mapGetters([
      'isOffline',
      'messageUnreadNumber',
      'profile',
      'snackBar',
      'typeFilter',
    ]),
    filterNav(): { icon: string, class: { active: boolean, [iconName: string]: boolean }, name: string } {
      const filter = this.typeFilter;
      if (filter) {
        return {
          icon: filter.iconName,
          class: Object.fromEntries([
            [filter.iconName, true],
            ['active', this.filterSliderActive],
          ]),
          name: this.$t(`app.advertType.${filter.display}`) as string,
        };
      }

      return {
        icon: 'nv-content-filter',
        class: {active: this.filterSliderActive},
        name: this.$t('app.template.bottomNavBar.filter') as string,
      };
    },
    heightSection(): number {
      return this.windowHeight ? (this.windowHeight - 112) : 0;
    },
    isAdvertList(): boolean {
      return this.$route.name === 'AdvertList';
    },
    isTypeActive(): boolean {
      return [
        'AdvertList',
        'PersonalAdvertList',
        'DefaultList',
        'FavoriteList',
      ].includes(this.$route.name || '');
    },
    selectedType(): AdvertType {
      return this.typeFilter;
    },
  },

  created() {
    this.windowHeight = window.innerHeight;

    window.addEventListener('resize', () => {
      this.windowHeight = window.innerHeight;
    });

    this.profileLoaded = false;
  },

  beforeRouteUpdate(to, from, next) {
    if (to.name !== 'SearchResult') {
      store.dispatch('changeSearchFieldStatus', false);
      store.dispatch('saveSearchTerm', '');
    }

    store.dispatch(
        'updateAppBarContext',
        {
          type: '',
          status: false,
        },
    );
    next();
  },

  methods: {
    ...mapActions([
      'changeSearchFieldStatus',
      'closeSnackBar',
      'loadProfile',
      'messageNotReadNumber',
      'selectTypeFilter',
    ]),
    onFilterClick(): Promise<void> {
      return new Promise((resolve, reject) => {
        if (this.typeFilter) {
          this.filterSliderActive = false;
          let query = Object.assign({}, this.$route.query);
          delete query.types;
          this.$router.push({
            name: this.$route.name || '',
            query: query,
          })
              .then(() => {
                resolve();
              })
              .catch(() => {
                reject();
              });
        } else {
          this.navSliderActive = false;
          this.filterSliderActive = !this.filterSliderActive;
          resolve();
        }
      });
    },
    onNavClick(): void {
      this.navSliderActive = !this.navSliderActive;
      this.filterSliderActive = false;
    },
    onNavigate(routeName: string): Promise<void> {
      return new Promise((resolve, reject) => {
        this.navSliderActive = false;
        this.filterSliderActive = false;
        this.$router.push({name: routeName})
            .then(() => {
              resolve();
            })
            .catch(() => {
              reject();
            });
      });
    },
    routeActive(routeName: string): boolean {
      return this.$route.name === routeName;
    },
  },
});
